import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import FacilityDetails from './facilityDetails';

export default class AddFacility extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            errors: []
        };
    }

    handleShow = () => {
        this.setState({ show: true }, () => {
            let elements = document.getElementsByClassName('removeTabIndexModal');
            if (elements.length) {
                for (let i = 0; i < elements.length; i++) {
                    let dialog = elements[i];
                    dialog.parentNode.removeAttribute('tabindex');
                }
            }
        });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        return (
            <div>
                <button className="btn btn-primary button-info-grid" onClick={() => this.handleShow()}>
                    <i className="fas fa-user-plus"></i> Add Facility
                </button>
                <ModalStyled
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                    dialogClassName="removeTabIndexModal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Add Facility Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FacilityDetails handleClose={this.handleClose} context={this.props.context} />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
